import api from "./api"

const cleanParams = (params = {}) =>
  Object.fromEntries(
    Object.entries(params).filter(
      ([, value]) =>
        value !== undefined &&
        value !== null &&
        value !== "" &&
        value !== "all"
    )
  )

export const getHrPerformanceFormData = async () =>
  (await api.get("/hr/performance/form-data")).data

export const getHrPerformanceSummary = async (params = {}) =>
  (
    await api.get("/hr/performance/summary", {
      params: cleanParams(params),
    })
  ).data

export const getHrPerformanceAutomaticPreview = async (params = {}) =>
  (
    await api.get("/hr/performance/automatic-preview", {
      params: cleanParams(params),
    })
  ).data

export const getHrPerformanceReviews = async (params = {}) =>
  (
    await api.get("/hr/performance", {
      params: cleanParams(params),
    })
  ).data

export const getPerformanceReviews = getHrPerformanceReviews
export const getHrPerformance = getHrPerformanceReviews
export const getPerformance = getHrPerformanceReviews
export const listPerformance = getHrPerformanceReviews

export const getHrPerformanceReviewById = async (reviewId) =>
  (await api.get(`/hr/performance/${reviewId}`)).data

export const createHrPerformanceReview = async (payload) =>
  (await api.post("/hr/performance", payload)).data

export const updateHrPerformanceReview = async (reviewId, payload) =>
  (await api.put(`/hr/performance/${reviewId}`, payload)).data

export const syncHrPerformanceAutomaticMetrics = async (reviewId) =>
  (await api.post(`/hr/performance/${reviewId}/sync-automatic`, {})).data

export const submitHrPerformanceReview = async (reviewId) =>
  (await api.post(`/hr/performance/${reviewId}/submit`, {})).data

export const validateHrPerformanceReview = async (reviewId) =>
  (await api.post(`/hr/performance/${reviewId}/validate`, {})).data

export const cancelHrPerformanceReview = async (reviewId, payload = {}) =>
  (await api.post(`/hr/performance/${reviewId}/cancel`, payload)).data

export const deleteHrPerformanceReview = async (reviewId) =>
  (await api.delete(`/hr/performance/${reviewId}`)).data

export const createHrPerformanceGoal = async (reviewId, payload) =>
  (await api.post(`/hr/performance/${reviewId}/goals`, payload)).data

export const updateHrPerformanceGoal = async (
  reviewId,
  goalId,
  payload
) =>
  (
    await api.put(
      `/hr/performance/${reviewId}/goals/${goalId}`,
      payload
    )
  ).data

export const deleteHrPerformanceGoal = async (reviewId, goalId) =>
  (
    await api.delete(
      `/hr/performance/${reviewId}/goals/${goalId}`
    )
  ).data

export const createPerformanceReview = createHrPerformanceReview
export const updatePerformanceReview = updateHrPerformanceReview
export const submitPerformanceReview = submitHrPerformanceReview
export const validatePerformanceReview = validateHrPerformanceReview
export const cancelPerformanceReview = cancelHrPerformanceReview
export const deletePerformanceReview = deleteHrPerformanceReview
export const getPerformanceFormData = getHrPerformanceFormData
export const getPerformanceSummary = getHrPerformanceSummary
export const getPerformanceReviewById = getHrPerformanceReviewById
export const getPerformanceAutomaticPreview = getHrPerformanceAutomaticPreview
export const syncPerformanceAutomaticMetrics =
  syncHrPerformanceAutomaticMetrics
